/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Lock_SuccessInputs */



/**
* | output |
* | --- |
* | "Event group has been locked." |
*
* @param {Event_Group_Options_Lock_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_lock_success = /** @type {((inputs?: Event_Group_Options_Lock_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Lock_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Event group has been locked.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Event group has been locked.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Event group has been locked.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Event group has been locked.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Event group has been locked.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Event group has been locked.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Event group has been locked.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Event group has been locked.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Event group has been locked.")
	return /** @type {LocalizedString} */ ("Event group has been locked.")
});